export default __webpack_public_path__ + "static/media/7-BFDC-meeting-with-subcool.8adbaf7e.jpg";